/**
 * Redeem Token Page
 * Handles deep links for redeeming OBC tokens
 * - If logged in: redirects to /my-links with token pre-filled
 * - If not logged in: redirects to /login with return URL
 */
import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function RedeemTokenPage() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  // Get token from URL params or query string
  const tokenCode = token || searchParams.get('token');

  console.log('[RedeemTokenPage] Render:', { token, tokenCode, isAuthenticated, loading });

  useEffect(() => {
    console.log('[RedeemTokenPage] useEffect:', { tokenCode, isAuthenticated, loading });
    
    if (loading) {
      console.log('[RedeemTokenPage] Still loading auth...');
      return;
    }

    if (!tokenCode) {
      console.log('[RedeemTokenPage] No token, redirecting to login');
      navigate('/login');
      return;
    }

    if (isAuthenticated) {
      // User is logged in - go to my-links with token
      const targetUrl = `/my-links?redeem=${encodeURIComponent(tokenCode)}`;
      console.log('[RedeemTokenPage] Authenticated, navigating to:', targetUrl);
      navigate(targetUrl, { replace: true });
    } else {
      // User not logged in - redirect to login with full return URL including token
      const returnUrl = `/my-links?redeem=${encodeURIComponent(tokenCode)}`;
      console.log('[RedeemTokenPage] Not authenticated, redirecting to login with return:', returnUrl);
      navigate(`/login?redirect=${encodeURIComponent(returnUrl)}`, { replace: true });
    }
  }, [isAuthenticated, loading, tokenCode, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Caricamento...</p>
      </div>
    </div>
  );
}
